import React from 'react';

import './password-peeker.scss';

export default function PasswordPeeker({ passwordVisible, onChange }) {
    const clickHandler = () => {
        if (onChange) {
            onChange({
                passwordVisible: !passwordVisible
            });
        }
    };

    return (
        <i onClick={clickHandler} className={`app-password-peeker-eye ${passwordVisible ? 'fa fa-eye' : 'fa fa-eye-slash'}`}></i>
    );
}
